<template>
  <div class="campaign-preview-option">
    <h3>{{ $t('CampaignForm_Preview_Workflow_Messages') }}</h3>
    <div class="email-select-ct">
      <el-select
        v-if="emails.length"
        v-model="selectedEmailId"
        @change="onChange"
      >
        <el-option
          v-for="email in emails"
          :key="email.workflow_action_id"
          :label="email.name + ' - ' + email.subject_line"
          :value="email.workflow_action_id"
        >
          <el-tooltip
            :open-delay="600"
            :content="email.name + ' - ' + email.subject_line"
            placement="top"
          >
            <div class="label">
              {{ email.name + ' - ' + email.subject_line }}
            </div>
          </el-tooltip>
        </el-option>
      </el-select>
      <div v-else>
        {{ $t('CampaignForm_Preview_Workflow_NoMessages') }}
      </div>
    </div>
  </div>
</template>

<script>
import { projectEndpoint } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'

export default {
  name: 'SidebarWorkflowEmailSelector',

  props: {
    model: {
      type: Object,
      required: true
    },
    variantKey: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      selectedEmail: null,
      selectedEmailId: null,
      emails: []
    }
  },

  mounted() {
    this.getEmails()
  },

  methods: {
    async getEmails() {
      // prettier-ignore
      const workflowId = this.model.messages[12][this.variantKey]['content']['workflow_id']

      if (!workflowId) {
        this.emails = []
        this.selectedEmailId = null
        this.selectedEmail = {}
        this.$emit('workflow-email-change', this.selectedEmail)

        return
      }

      await RestApi(
        projectEndpoint({
          method: 'get',
          url: `workflows/${workflowId}/emails`,
          params: {
            variantKey: this.variantKey
          }
        })
      ).then(({ data }) => {
        this.emails = data
        this.selectedEmailId = data[0] ? data[0].workflow_action_id : null
        this.selectedEmail = data[0] ? data[0] : {}
        this.$emit('workflow-email-change', this.selectedEmail)
      })
    },

    onChange(workflowActionId) {
      this.selectedEmail = this.emails.filter(item => {
        return item.workflow_action_id === workflowActionId
      })[0]

      this.$emit('workflow-email-change', this.selectedEmail)
    }
  },

  watch: {
    variantKey: {
      handler() {
        this.getEmails()
      }
    }
  }
}
</script>
<style scoped>
.email-select-ct {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

h3 {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: #4b515f;
}

.campaign-preview-option {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/preview/SidebarWorkflowEmailSelector.vue